/* ══════════════════════════════════════════════════════════════════════
   PREVIEW-PERF.JS — APERÇU LOCAL UNIQUEMENT. NE PAS LIVRER.

   build.sh ne package que le dossier theme/, donc ce fichier ne peut pas
   se retrouver dans le zip vendu.

   À quoi ça sert : arrêter de deviner. Le panneau affiche les images par
   seconde et, surtout, la pire image de la dernière seconde — une chute
   de 60 à 30 se voit dans la moyenne, mais un à-coup isolé ne se voit que
   là. Chaque interrupteur éteint UN suspect. On bouge la souris, on
   défile, on regarde le chiffre : celui qui le fait remonter est le
   coupable.

   Touche P pour ouvrir ou fermer.
   ══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var panel, fpsEl, worstEl, landEl, open = false;

  /* ── mesure ────────────────────────────────────────────────────────
     On compte les images sur une fenêtre glissante d'une seconde et on
     retient le plus long intervalle. 16.7 ms = 60 fps, 33 ms = 30 fps.  */
  var frames = 0, worst = 0, last = performance.now(), since = last;

  function tick(now) {
    var dt = now - last; last = now;
    frames++;
    if (dt > worst) worst = dt;
    if (now - since >= 1000) {
      if (open) {
        fpsEl.textContent   = Math.round(frames * 1000 / (now - since));
        worstEl.textContent = worst.toFixed(0) + ' ms';
        var L = window.__landing;
        if (landEl) landEl.textContent = L
          ? 'x ' + L.x.toFixed(2) + '  y ' + L.y.toFixed(2) +
            '  largeur ' + L.w.toFixed(2)
          : '—';
        worstEl.style.color = worst > 50 ? '#E5484D' : worst > 25 ? '#F5A623' : '#30A46C';
      }
      frames = 0; worst = 0; since = now;
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  /* ── les suspects ──────────────────────────────────────────────────
     Chacun coupe une seule chose, sans toucher aux autres.            */
  var CSS = document.createElement('style');
  document.head.appendChild(CSS);
  var off = {};

  var SUSPECTS = [
    { id: 'cursor',
      label: 'Curseur (mix-blend-mode)',
      why:  'Le fondu par différence oblige le navigateur à relire le fond sous le curseur à chaque image.',
      css:  '.cursor { display: none !important; }' },

    { id: 'videos',
      label: 'Vidéos du mur (×3)',
      why:  'Trois décodeurs matériels tournent en continu tant que le mur est à l’écran.',
      run:  function (on) {
        document.querySelectorAll('.wall-tile video').forEach(function (v) {
          if (on) { v.pause(); v.style.visibility = 'hidden'; }
          else    { v.style.visibility = ''; v.play().catch(function () {}); }
        });
      } },

    { id: 'tiles',
      label: 'Mur : 84 → 45 tuiles',
      why:  'Chaque tuile est un calque composité à part (backface-visibility dans une scène 3D).',
      css:  '.wall-tile:nth-child(n+46) { display: none !important; }' },

    { id: 'wall',
      label: 'Mur entier',
      why:  'Coupe la scène 3D complète — perspective, calques et vidéos d’un coup.',
      css:  '.wall { display: none !important; }' },

    { id: 'blur',
      label: 'Flou de la barre',
      why:  'backdrop-filter refiltre ce qui passe derrière la barre à chaque image.',
      css:  '.hdr.is-stuck { backdrop-filter: none !important; }' },

    { id: 'grain',
      label: 'Grain + voile du hero',
      why:  'Textures superposées repeintes avec le hero.',
      css:  '.hero-veil, .grain::after { display: none !important; }' }
  ];

  function repaint() {
    CSS.textContent = SUSPECTS.filter(function (s) { return off[s.id] && s.css; })
                              .map(function (s) { return s.css; }).join('\n');
  }

  /* ── panneau ───────────────────────────────────────────────────────*/
  function build() {
    panel = document.createElement('div');
    panel.setAttribute('data-preview-perf', '');
    panel.style.cssText =
      'position:fixed;right:14px;bottom:14px;z-index:9999;width:250px;' +
      'background:#111;color:#EEE;font:11px/1.45 ui-monospace,Menlo,monospace;' +
      'padding:12px 13px;border-radius:6px;box-shadow:0 8px 30px rgba(0,0,0,.4)';

    var head = document.createElement('div');
    head.style.cssText = 'display:flex;justify-content:space-between;align-items:baseline;' +
                         'margin-bottom:9px;padding-bottom:9px;border-bottom:1px solid #333';
    head.innerHTML = '<b style="font-size:22px;font-weight:600" id="pp-fps">—</b>' +
                     '<span style="opacity:.55">fps · pire <b id="pp-worst">—</b></span>';
    panel.appendChild(head);

    /* Écart résiduel entre le nom qui atterrit et celui de la barre, tel
       que le navigateur le mesure après correction. 0.00 partout = ils se
       superposent exactement, et ce qu'on croit voir bouger est ailleurs. */
    var land = document.createElement('div');
    land.style.cssText = 'margin:-3px 0 8px;padding-bottom:9px;border-bottom:1px solid #333;opacity:.55';
    land.innerHTML = 'atterrissage <b id="pp-land">—</b>';
    panel.appendChild(land);
    landEl = land.querySelector('#pp-land');

    SUSPECTS.forEach(function (s) {
      var row = document.createElement('label');
      row.style.cssText = 'display:flex;gap:8px;align-items:flex-start;padding:5px 0;cursor:pointer';
      row.title = s.why;
      var box = document.createElement('input');
      box.type = 'checkbox';
      box.style.cssText = 'margin:2px 0 0;flex:none';
      box.addEventListener('change', function () {
        off[s.id] = box.checked;
        if (s.run) s.run(box.checked);
        repaint();
      });
      var txt = document.createElement('span');
      txt.textContent = s.label;
      row.appendChild(box); row.appendChild(txt);
      panel.appendChild(row);
    });

    var foot = document.createElement('div');
    foot.style.cssText = 'margin-top:9px;padding-top:9px;border-top:1px solid #333;opacity:.5';
    foot.textContent = 'Coche pour éteindre. P pour fermer.';
    panel.appendChild(foot);

    document.body.appendChild(panel);
    fpsEl   = panel.querySelector('#pp-fps');
    worstEl = panel.querySelector('#pp-worst');
  }

  addEventListener('keydown', function (e) {
    if (e.key !== 'p' && e.key !== 'P') return;
    if (/^(INPUT|TEXTAREA)$/.test(e.target.tagName)) return;
    if (!panel) build();
    open = !open;
    panel.style.display = open ? '' : 'none';
  });
})();
